



// import React, { useState } from "react";
// import robotics from "../img/aaaservices/digital.webp";
// import { useNavigate } from 'react-router-dom';

// const KeyFuturesSection = () => {
//     const [showPopup, setShowPopup] = useState(false);

//     const navigate = useNavigate();


//     const goToEnquirySection = () => 
//       navigate('/contact#enquiry');

// const goToCartPage = () => {
//   navigate('/cart-page');
// };
// const handleFilter = (filterType) => {
//         // Navigate to homepage with a filter query or state
//         navigate('/', { state: { filter: filterType } });
//     };


//     const openPopup = () => setShowPopup(true);
//     const closePopup = () => setShowPopup(false);



//     const [formData, setFormData] = useState({
//         name: "",
//         email: "",
//         phone: "",
//         date: "",
//         gender: "",
//         message: "",
//         plan: "",
//         cources: "",
//     });

//     // const handleChange = (e) => {
//     //     const { id, value } = e.target;
//     //     setFormData((prev) => ({
//     //         ...prev,
//     //         [id]: value,
//     //     }));
//     // };

//     const handleChange = (e) => {
//         const { id, value } = e.target;
//         setFormData((prev) => ({
//             ...prev,
//             [id]: value,
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const apiBody = {
//             name: formData.name,
//             emailId: formData.email,
//             mobileNumber: formData.phone,
//             dateOfBirth: formData.date,
//             gender: formData.gender,
//             message: formData.message,
//             plan: formData.plan,
//             cources: formData.cources,
//         };

//         try {
//             const response = await fetch("http://iiaserver.iiautomate/IIA-Website-1.0.0/enquiry/add", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify(apiBody),
//             });

//             if (response.ok) {
//                 alert("Your details have been submitted successfully!");
//                 setFormData({
//                     name: "",
//                     email: "",
//                     phone: "",
//                     date: "",
//                     gender: "",
//                     message: "",
//                     plan: "",
//                     cources: "",
//                 });
//                 closePopup();
//             } else {
//                 alert("There was an issue submitting your details.");
//             }
//         } catch (error) {
//             alert("Something went wrong. Please try again later.");
//         }
//     };

//     const inputStyle = {
//         padding: "10px",
//         fontSize: "14px",
//         borderRadius: "5px",
//         border: "1px solid #ccc",
//         fontFamily: "Roboto",
//     };



//     return (

//         <div>
//             <div style={{
//                 position: 'fixed',
//                 top: '83px',
//                 width: '100%',
//                 backgroundColor: 'white',
//                 zIndex: '1000',
//                 padding: '10px 0',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: '10px'
//             }}>
//                 <button
//                     onClick={() => handleFilter('TecTalks')}
//                     style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
//                 >
//                     TecTalks
//                 </button>
//                 <button
//                     onClick={() => handleFilter('Programs')}
//                     style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
//                 >
//                     Programs
//                 </button>
//                 {/* <button
//                     onClick={() => handleFilter('jbs')}
//                     style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
//                 >
//                     Jobs
//                 </button>
//                 <button
//                     onClick={() => handleFilter('WalkingDrive')}
//                     style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
//                 >
//                     WalkingDrive
//                 </button> */}
//             </div>
//         <div className="container mt-5">
//             <div>
//                 <div className="webinarsss" style={{ fontSize: '30px', color: 'black', fontFamily: 'Roboto', fontWeight: 'bold', textAlign: 'center', marginTop: '75px' }}>
//                  Digital <span style={{ color: 'blue' }}>skills</span>
//                 </div>
//             <div className="row d-flex align-items-start" style={{ marginTop: "5px" }}>
//                 {/* Content Section */}
//                 <div className="col-md-7">
//                     <div className="p-4 bg-white shadow rounded mb-4 digitalpreence-key" style={{ height: '301px', }}>
//                         <h2 style={{ fontWeight: "bold", fontSize: '22px', }}>
//                             DIGITAL PRESENCE SKILLS  {" "}
//                             <span style={{ color: "#ffa500", fontWeight: "800" }}>ENHANCEMENT

//                             </span>
//                         </h2>
//                         <p style={{ paddingBottom: '45px', textAlign: 'justify', fontFamily: 'roboto' }}>
//                             In today's fast-paced digital world, building and maintaining an effective online presence is
//                             essential. Master the art of creating engaging content, leveraging social media platforms, optimizing
//                             your personal brand, and navigating tools to leave a lasting impression in the virtual space.Digital Presence Skills refer to the ability to effectively establish, manage, and utilize one's online presence across digital platforms for personal, professional, or business purposes. Here's some relevant data and insights about digital presence skills:
//                         </p>
//                         <div
//                             className="disccccreting"
//                             style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'left',
//                                 gap: '20px',
//                                 marginTop: '-36px',
//                                 flexWrap: 'wrap', // Allows wrapping in smaller screens
//                             }}
//                         >
//                             {/* Rating Section */}
//                             <div style={{ display: 'flex', alignItems: 'center', gap: '5px', flex: '1 1 auto' }}>
//                                 <span style={{ fontSize: '16px', fontWeight: 'bold' }}>4.5</span>
//                                 <div style={{ display: 'flex', fontSize: '20px', flex: '1 1 auto' }}>
//                                     <span style={{ color: '#FFD700' }}>★</span>
//                                     <span style={{ color: '#FFD700' }}>★</span>
//                                     <span style={{ color: '#FFD700' }}>★</span>
//                                     <span style={{ color: '#FFD700' }}>★</span>
//                                     <span style={{ color: '#FFD700', position: 'relative' }}>
//                                         <span
//                                             style={{
//                                                 color: '#fff',
//                                                 position: 'absolute',
//                                                 left: '8px',
//                                                 overflow: 'hidden',
//                                                 width: '10px',
//                                             }}
//                                         >
//                                             ★
//                                         </span>
//                                     </span>
//                                 </div>

//                                 {/* Buttons Wrapper */}
//                                 <div
//                                     style={{
//                                         display: 'flex',
//                                         gap: '10px',
//                                         flex: '1 1 auto',
//                                         justifyContent: 'flex-end',
//                                         flexWrap: 'wrap',
//                                     }}
//                                 >
//                                     {/* Wishlist Button */}
//                                    <a
//                                                 href="/brochure.pdf" // Path to the file in the public folder
//                                                 download="brochure.pdf" // This triggers the download
//                                                 style={{
//                                                     textDecoration: 'none',
//                                                     display: 'inline-block',
//                                                 }}
//                                             >
//                                                 <button
//                                                     style={{
//                                                         padding: '10px 20px',
//                                                         fontSize: '14px',
//                                                         backgroundColor: '#007bff',
//                                                         color: 'white',
//                                                         border: '1px solid #ccc',
//                                                         borderRadius: '5px',
//                                                         fontFamily: 'roboto',
//                                                         fontWeight: 'bold',
//                                                         cursor: 'pointer',
//                                                         flex: '1 1 auto',
//                                                         minWidth: '120px',
//                                                     }}
//                                                 >
//                                                     Brochure
//                                                 </button>
//                                             </a>




// <button
//                                                 onClick={goToCartPage}
//                                                 style={{
//                                                     padding: '10px 20px',
//                                                     fontSize: '14px',
//                                                     backgroundColor: '#007bff',
//                                                     color: '#fff',
//                                                     border: 'none',
//                                                     borderRadius: '5px',
//                                                     fontFamily: 'roboto',
//                                                     fontWeight: 'bold',
//                                                     cursor: 'pointer',
//                                                     flex: '1 1 auto',
//                                                     minWidth: '120px',
//                                                 }}
//                                             >
//                                                 Add to Cart
//                                             </button>

//                                     {/* Enquiry Now Button */}
                                    
// <button
//                                                 onClick={goToEnquirySection}
//                                                 style={{
//                                                     padding: '10px 20px',
//                                                     fontSize: '14px',
//                                                     backgroundColor: '#007bff',
//                                                     color: '#fff',
//                                                     border: 'none',
//                                                     borderRadius: '5px',
//                                                     fontFamily: 'roboto',
//                                                     fontWeight: 'bold',
//                                                     cursor: 'pointer',
//                                                     flex: '1 1 auto',
//                                                     minWidth: '120px',
//                                                 }}
//                                             >
//                                                 Enquiry Now
//                                             </button>
//                                 </div>
//                             </div>

//                             {showPopup && (
//                                 <div
//                                     style={{
//                                         position: 'fixed',
//                                         top: 0,
//                                         left: 0,
//                                         width: '100%',
//                                         height: '100%',
//                                         backgroundColor: 'rgba(0,0,0,0.5)',
//                                         display: 'flex',
//                                         justifyContent: 'center',
//                                         alignItems: 'center',
//                                         zIndex: 1000,
//                                         overflow: 'hidden'
//                                     }}
//                                 >
//                                     <div
//                                         style={{
//                                             backgroundColor: '#fff',
//                                             borderRadius: '10px',
//                                             padding: '30px',
//                                             width: '90%',
//                                             maxWidth: '463px',
//                                             height: '630px',
//                                             marginTop: "90px",
//                                             boxShadow: '0 0 20px rgba(0,0,0,0.3)',
//                                             position: 'relative',
//                                         }}
//                                     >
//                                         <button
//                                             onClick={closePopup}
//                                             style={{
//                                                 position: 'absolute',
//                                                 top: '10px',
//                                                 right: '15px',
//                                                 border: 'none',
//                                                 background: 'transparent',
//                                                 fontSize: '20px',
//                                                 cursor: 'pointer',
//                                                 fontWeight: 'bold',
//                                                 color: '#333',

//                                             }}
//                                         >
//                                             ×
//                                         </button>

//                                         <h2 style={{ textAlign: 'center', fontFamily: 'Roboto', marginBottom: '20px', fontSize: '22px', fontWeight: 'bold' }}>
//                                             Welcome to <span style={{ color: "blue" }}>International Institute of </span>
//                                             <span style={{ color: "orange" }}>Automate</span>
//                                         </h2>

//                                         <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
//                                             <input
//                                                 id="name"
//                                                 value={formData.name}
//                                                 onChange={handleChange}
//                                                 type="text"
//                                                 placeholder="Name"
//                                                 required
//                                                 style={inputStyle}
//                                             />
//                                             <input
//                                                 id="email"
//                                                 value={formData.email}
//                                                 onChange={handleChange}
//                                                 type="email"
//                                                 placeholder="Email"
//                                                 required
//                                                 style={inputStyle}
//                                             />
//                                             <input
//                                                 id="phone"
//                                                 value={formData.phone}
//                                                 onChange={handleChange}
//                                                 type="tel"
//                                                 placeholder="Phone"
//                                                 required
//                                                 style={inputStyle}
//                                             />
//                                             <input
//                                                 id="date"
//                                                 value={formData.date}
//                                                 onChange={handleChange}
//                                                 type="date"
//                                                 required
//                                                 style={inputStyle}
//                                             />
//                                             <select
//                                                 id="gender"
//                                                 value={formData.gender}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={{ ...inputStyle, cursor: "pointer" }}
//                                             >
//                                                 <option value="">Select Gender</option>
//                                                 <option value="Male">Male</option>
//                                                 <option value="Female">Female</option>
//                                                 <option value="Other">Other</option>
//                                             </select>

//                                             <select
//                                                 id="cources"
//                                                 name="cources" // <-- This is important
//                                                 value={formData.cources}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={{ ...inputStyle, cursor: "pointer" }}
//                                             >
//                                                 <option value="">Select courses</option>
//                                                 <option value="VirualRoboticsSimulation">Robotics Virtual Simulation</option>
//                                                 <option value="ToolandFixtureDesign">Tool & Fixture Design</option>
//                                                 <option value="DigitalFactorySolution">Digital Factory Solution</option>
//                                                 <option value="JavaFullStackDevelopers">Java Full Stack Developers</option>
//                                                 <option value="PythonFullStackDevelopers">Python Full Stack Developers</option>
//                                                 <option value="ReactJsAndFlutterDevelopers">React & Flutter Developers</option>
//                                                 <option value="CareerFoundationSkills">Career Foundation Skill</option>
//                                                 <option value="SoftSkillsEnhancement">Soft Skill</option>
//                                                 <option value="DigitalPresenceSkills">Digital Presence Skill</option>
//                                             </select>


//                                             <select
//                                                 id="plan"
//                                                 value={formData.plan}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={{ ...inputStyle, cursor: "pointer" }}
//                                             >
//                                                 <option value="">Select plane</option>
//                                                 <option value="Industrial_Oriented_Training_Program">Industrial Oriented Training Program</option>
//                                                 <option value="Job_Oriented_Placement_Program">Job Oriented Placement Program</option>

//                                             </select>
//                                             <textarea
//                                                 id="message"
//                                                 value={formData.message}
//                                                 onChange={handleChange}
//                                                 placeholder="Message"
//                                                 rows="4"
//                                                 required
//                                                 style={{ ...inputStyle, resize: "vertical" }}
//                                             />
//                                             <button
//                                                 type="submit"
//                                                 style={{
//                                                     padding: "10px",
//                                                     fontSize: "14px",
//                                                     backgroundColor: "#007bff",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     borderRadius: "5px",
//                                                     fontWeight: "bold",
//                                                     cursor: "pointer",
//                                                     fontFamily: "Roboto",
//                                                 }}
//                                             >
//                                                 Submit
//                                             </button>
//                                         </form>
//                                     </div>
//                                 </div>
//                             )}

//                             <style>
//                                 {`
//                                                                @media (max-width: 768px) {
//                                                                  .disccccreting {
//                                                                    justify-content: center; /* Center-align items on smaller screens */
//                                                                    gap: 10px; /* Reduce gap for mobile view */
//                                                                  }
                                                           
//                                                                  .disccccreting button {
//                                                                    flex: 1 0 100%; /* Make buttons full-width */
//                                                                    text-align: center; /* Center button text */
//                                                                  }
                                                           
//                                                                  .disccccreting div {
//                                                                    flex: 1 0 100%; /* Ensure proper alignment for the rating section */
//                                                                    text-align: center; /* Center align rating */
//                                                                  }
//                                                                }
//                                                                `}
//                             </style>
//                         </div>
//                     </div>





//                     {/* <h3 style={{ fontWeight: "bold", color: "rgb(34 64 153)",textAlign:'left', marginTop:'40px' }}>Key Features</h3>
//                                                                                <div className="row">
//                                                                                    {[
//                                                                                        "Receive a prestigious certificate endorsed by IIA and I-Robotics, validating your expertise in tools and virtual robotics.",
//                                                                                        "Exclusive hackathons and Ask Me Anything sessions by IIA.",
//                                                                                        "Live sessions on the latest AI trends, such as generative AI, prompt engineering, explainable AI, and more.",
//                                                                                        "Capstone from 3 domains and 14+ Data Analytics Projects with Industry datasets.",
//                                                                                        "Master Classes delivered by Purdue faculty and IBM experts.",
//                                                                                        "We assist you to get noticed by top hiring companies.",
//                                                                                    ].map((feature, index) => (
//                                                                                        <div className="col-12 mb-3" key={index}>
//                                                                                            <div
//                                                                                                className="key-feature-box p-3 bg-white shadow rounded"
//                                                                                                style={{ border: "1px solid grey" }}
//                                                                                            >
//                                                                                                <li style={{ listStyleType: "none", borderRadius: "50px" }}>
//                                                                                                    {feature}
//                                                                                                </li>
//                                                                                            </div>
//                                                                                        </div>
//                                                                                    ))}
//                                                                                </div> */}
//                 </div>

//                 {/* Form and Video Section */}
//                 <div className="col-md-5-sideimage-all" style={{ borderRadius: '20px', }}>
//                     {/* Video */}
//                     <div style={{ marginBottom: "20px" }}>
//                         <img
//                             src={robotics}
//                             alt="Robotics Preview"
//                             style={{
//                                 width: "100%",
//                                 height: "301px",
//                                 borderRadius: "20px",
//                                 backgroundColor: "black",
//                                 objectFit: "cover",
//                                 boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
//                             }}
//                         />
//                     </div>
//                     {/* Form */}
//                     {/* <div
//                         style={{
//                             width: "100%",
//                             minHeight: "500px",
//                             maxHeight: "90vh",
//                             overflowY: "auto",
//                             padding: "30px",
//                             boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
//                             borderRadius: "10px",
//                             backgroundColor: "#fff",
//                             marginTop:'100px',
//                         }}
//                      >
//                         <h2 style={{ textAlign: "center" }}>Enquiry Form</h2>
//                         <form
//                             style={{ display: "flex", flexDirection: "column", gap: "15px" }}
//                             onSubmit={handleSubmit}
//                         >
//                             <input
//                                 type="text"
//                                 id="name"
//                                 placeholder="Name"
//                                 value={formData.name}
//                                 onChange={handleChange}
//                                 required
//                                 style={{
//                                     width: "100%",
//                                     padding: "10px",
//                                     fontSize: "16px",
//                                     borderRadius: "5px",
//                                     border: "1px solid #ccc",
//                                 }}
//                             />
//                             <input
//                                 type="email"
//                                 id="email"
//                                 placeholder="Email"
//                                 value={formData.email}
//                                 onChange={handleChange}
//                                 required
//                                 style={{
//                                     width: "100%",
//                                     padding: "10px",
//                                     fontSize: "16px",
//                                     borderRadius: "5px",
//                                     border: "1px solid #ccc",
//                                 }}
//                             />
//                             <input
//                                 type="tel"
//                                 id="phone"
//                                 placeholder="Phone Number"
//                                 value={formData.phone}
//                                 onChange={handleChange}
//                                 required
//                                 style={{
//                                     width: "100%",
//                                     padding: "10px",
//                                     fontSize: "16px",
//                                     borderRadius: "5px",
//                                     border: "1px solid #ccc",
//                                 }}
//                             />
//                             <input
//                                 type="date"
//                                 id="date"
//                                 value={formData.date}
//                                 onChange={handleChange}
//                                 required
//                                 style={{
//                                     width: "100%",
//                                     padding: "10px",
//                                     fontSize: "16px",
//                                     borderRadius: "5px",
//                                     border: "1px solid #ccc",
//                                 }}
//                             />
//                             <select
//                                 id="gender"
//                                 value={formData.gender}
//                                 onChange={handleChange}
//                                 required
//                                 style={{
//                                     width: "100%",
//                                     padding: "10px",
//                                     borderRadius: "5px",
//                                     border: "1px solid #ccc",
//                                 }}
//                             >
//                                 <option value="">Select Gender</option>
//                                 <option value="male">Male</option>
//                                 <option value="female">Female</option>
//                                 <option value="other">Other</option>
//                             </select>
//                             <textarea
//                                 id="message"
//                                 placeholder="Your Message"
//                                 rows="4"
//                                 value={formData.message}
//                                 onChange={handleChange}
//                                 style={{
//                                     width: "100%",
//                                     padding: "10px",
//                                     borderRadius: "5px",
//                                     border: "1px solid #ccc",
//                                     height:'50px'
//                                 }}
//                             />
//                             <button
//                                 type="submit"
//                                 style={{
//                                     padding: "12px",
//                                     backgroundColor: "#495057",
//                                     color: "#fff",
//                                     border: "none",
//                                     borderRadius: "5px",
//                                     cursor: "pointer",
//                                 }}
//                             >
//                                 Submit
//                             </button>
//                         </form>
//                     </div> */}
//                 </div>


//             </div>
//         </div>
//          </div>
//           </div>


//     );
// };

// export default KeyFuturesSection;







import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
 import robotics from "../img/aaaservices/digital.webp";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';

import jsPDF from "jspdf";
const KeyFuturesSection = () => {
    const navigate = useNavigate();
    const goToEnquirySection = () => navigate('/contact#enquiry');
    const handleFilter = (filterType) => {
        navigate('/Newallcardspage', { state: { filter: filterType } });
    };

    const [showPopup, setShowPopup] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);

    const openPopup = () => {
        setShowPopup(true);
        setSubmitted(false);
        setEmail('');
        setPhone('');
    };

    const closePopup = () => {
        setShowPopup(false);
    };

    const [courseDetails] = useState({
    name: 'digital presence Devlopment ',
    description: '  In todays fast-paced digital world, building and maintaining an effective online presence is essential. Master the art of creating engaging content',
                             
                            
    fee: '₹70000',
  });


    

    const styles = {
        overlayBg: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 999,
        },
        popup: {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#fff',
            padding: '20px',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
            zIndex: 1000,
            width: '90%',
            maxWidth: '400px',
        },
        bookBtn: {
            marginTop: '10px',
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            fontWeight: 'bold',
            width: '100%',
            cursor: 'pointer',
        }
    };



    const generatePDF = () => {
       
       
      const doc = new jsPDF();
    
      // Blue header bar
      doc.setFillColor(52, 152, 219); // blue color
      doc.rect(0, 10, 210, 15, 'F');
    
      // Main Heading (white text on blue)
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      doc.text("International Institute of Automation", 10, 20);
    
      // Sub-heading (course name) under main heading
      doc.setFontSize(12);
      doc.text("Course Name: Robotics Virtual Simulation", 10, 28);
    
      // Reset color for rest of the text (black)
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
    
      // Company address - example, you can customize
      doc.text("1912 Harvest Lane", 10, 40);
      doc.text("New York, NY 12210", 10, 46);
    
      // Bill To, Ship To and Invoice Details - sample layout
      doc.setFont("helvetica", "bold");
      doc.text("Bill To", 10, 60);
      doc.text("Ship To", 70, 60);
      doc.text("Invoice #", 140, 60);
    
      doc.setFont("helvetica", "normal");
      doc.text("John Smith", 10, 66);
      doc.text("2 Court Square", 10, 72);
      doc.text("New York, NY 12210", 10, 78);
    
      doc.text("John Smith", 70, 66);
      doc.text("3787 Pineview Drive", 70, 72);
      doc.text("Cambridge, MA 12210", 70, 78);
    
      doc.text("US-001", 140, 66);
      doc.text("Invoice Date: 11/02/2019", 140, 72);
      doc.text("P.O.# 2312/2019", 140, 78);
      doc.text("Due Date: 26/02/2019", 140, 84);
    
      // Draw table headers background
      doc.setFillColor(240, 240, 240);
      doc.rect(10, 90, 190, 10, 'F');
    
      // Table Headers
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold");
      doc.text("QTY", 15, 97);
      doc.text("DESCRIPTION", 40, 97);
      doc.text("UNIT PRICE", 140, 97, { align: "right" });
      doc.text("AMOUNT", 190, 97, { align: "right" });
    
      // Table rows
      doc.setFont("helvetica", "normal");
      const items = [
        { qty: 1, desc: "Front and rear brake cables", unitPrice: 100.00, amount: 100.00 },
        { qty: 2, desc: "New set of pedal arms", unitPrice: 15.00, amount: 30.00 },
        { qty: 3, desc: "Labor 3hrs", unitPrice: 5.00, amount: 15.00 },
      ];
    
      let y = 105;
      items.forEach(item => {
        doc.text(String(item.qty), 15, y);
        doc.text(item.desc, 40, y);
        doc.text(item.unitPrice.toFixed(2), 140, y, { align: "right" });
        doc.text(item.amount.toFixed(2), 190, y, { align: "right" });
        y += 10;
      });
    
      // Subtotal and taxes
      doc.text("Subtotal", 140, y + 5, { align: "right" });
      doc.text("145.00", 190, y + 5, { align: "right" });
    
      doc.text("Sales Tax 6.25%", 140, y + 12, { align: "right" });
      doc.text("9.06", 190, y + 12, { align: "right" });
    
      doc.setFont("helvetica", "bold");
      doc.text("TOTAL", 140, y + 20, { align: "right" });
      doc.text("$154.06", 190, y + 20, { align: "right" });
    
      // Signature image placeholder - you can replace this with actual image with doc.addImage()
      doc.setFont("helvetica", "normal");
      doc.text("John Smith", 140, y + 45);
    
      // Footer text
      doc.setFontSize(8);
      doc.text("Terms & Conditions", 10, y + 60);
      doc.text("Payment is due within 15 days.", 10, y + 65);
      doc.text("Please make checks payable to: East Repair Inc.", 10, y + 70);
    
      // Save the PDF
      doc.save("custom_invoice.pdf");
    };
    
    
      const initiatePayment = async () => {
        setLoading(true);
    
        // Payment and transaction details
    
        // Razorpay Payment Options for paid courses
        var options = {
          key: "rzp_test_oqm83qg9Z710lA",
          key_secret: "eaHmzOnTh2AqXLFRFWavB29c",
          amount: 1 * 100, // Convert price to paise
          currency: "INR",
          payment_capture: true,
          name: "International Institute Of Automate",
          handler: async function (response) {
            alert(
              "Thanks For Your Interest \n Your Payment has been successfully completed"
            );
            generatePDF();
            // Call API to update payment status
    
          },
          notes: {
            address: "International Institute Of Automate",
          },
          theme: {
            color: "#3399cc",
          },
        };
    
        var pay = new window.Razorpay(options);
        pay.open();
      }

    return (
        <div>
            {/* Fixed Filter Buttons */}
            <div style={{
                position: 'fixed',
                top: '83px',
                width: '100%',
                backgroundColor: 'white',
                zIndex: '1000',
                padding: '10px 0',
                display: 'flex',
                justifyContent: 'center',
                gap: '10px'
            }}>
                <button
                    onClick={() => handleFilter('TecTalks')}
                    style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
                >
                    TecTalks
                </button>
                <button
                    onClick={() => handleFilter('Programs')}
                    style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
                >
                    Programs
                </button>
            </div>

            {/* Title */}
            <div className="webinarsss" style={{ fontSize: '30px', color: 'black', fontFamily: 'Roboto', fontWeight: 'bold', textAlign: 'center', marginTop: '158px' }}>
             DIGITAL PRESENCE   <span style={{ color: 'blue' }}>SKILLS</span>
            </div>

            <div className="container mt-5">
                <div className="row d-flex align-items-start" style={{ marginTop: "30px" }}>
                    {/* Content Section */}
                    <div className="col-md-7">
                        <div className="p-4 bg-white shadow rounded mb-4 virtual-key" style={{ height: 'auto' }}>
                            <h2 style={{ fontWeight: "bold", fontSize: '22px', fontFamily: 'roboto' }}>
                                <span style={{ color: 'blue' }}>  DIGITAL PRESENCE SKILLS  </span><span style={{ color: 'orange' }}>ENACHMENTS</span>
                            </h2>
                            <p style={{ textAlign: 'justify', fontFamily: 'roboto' }}>
                                  In today's fast-paced digital world, building and maintaining an effective online presence is
                             essential. Master the art of creating engaging content, leveraging social media platforms, optimizing
                             your personal brand, and navigating tools to leave a lasting impression in the virtual space.Digital Presence Skills refer to the ability to effectively establish, manage, and utilize one's online presence across digital platforms for personal, professional, or business purposes. Here's some relevant data and insights about digital presence skills:
                            </p>

                            <div className="disccccreting" style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', gap: '20px', marginTop: '19px', flexWrap: 'wrap' }}>

                              

                                <span style={{ fontSize: '16px', fontWeight: 'bold' }}>4.5</span>
                                <div style={{ display: 'flex', fontSize: '20px', flex: '1 1 auto' }}>
                                    <span style={{ color: '#FFD700' }}>★</span>
                                    <span style={{ color: '#FFD700' }}>★</span>
                                    <span style={{ color: '#FFD700' }}>★</span>
                                    <span style={{ color: '#FFD700' }}>★</span>
                                    <span style={{ color: '#FFD700', position: 'relative' }}>                                                     <span style={{ color: '#fff', position: 'absolute', left: '8px', overflow: 'hidden', width: '10px' }}>★</span>                                                 </span>
                                </div>



                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '20px' }}>
                                    <a href="/brochure.pdf" download="brochure.pdf" style={{ textDecoration: 'none' }}>
                                        <button style={{ padding: '10px 20px', fontSize: '14px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', fontWeight: 'bold' }}>
                                            Brochure
                                        </button>
                                    </a>
                                    <button
                                        onClick={openPopup}
                                        style={{
                                            padding: '10px 20px',
                                            fontSize: '14px',
                                            backgroundColor: '#007bff',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '5px',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Book Now
                                    </button>

                                    <button onClick={goToEnquirySection} style={{ padding: '10px 20px', fontSize: '14px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', fontFamily: 'roboto', fontWeight: 'bold', cursor: 'pointer', minWidth: '120px' }}>Enquiry Now</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Image Section */}
                    <div className="col-md-5">
                        <img src={robotics} alt="Robotics" style={{ width: '100%', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.2)', height: '308px' }} />
                    </div>
                </div>
            </div>

            {/* Popup Form */}
            {showPopup && (
                <>
                    <div style={styles.overlayBg} onClick={closePopup} />
                    <div style={styles.popup}>
                        {!submitted ? (
                            <>
                                <h3 style={{ color: 'blue', fontSize: '20px' }}>Enter Your Details</h3>
                                <input
                                    type="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    style={{ width: '100%', padding: '8px', margin: '5px 0' }}
                                />
                                <input
                                    type="tel"
                                    placeholder="Phone"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    style={{ width: '100%', padding: '8px', margin: '5px 0' }}
                                />
                                <button style={styles.bookBtn} onClick={() => setSubmitted(true)}>
                                    Proceed to Pay
                                </button>
                            </>
                        ) : (
                            <>
                                <h3 style={{ color: 'green', fontSize: '20px' }}></h3>
                                <p style={{fontFamily:'math',color:'blue'}}>Email: {email}</p>
                                <p style={{fontFamily:'math',color:'blue'}}>Phone: {phone}</p>
                                <p style={{fontFamily:'math',color:'black'}}>Course: { courseDetails.name}</p>
                                <p style={{fontFamily:'math',color:'black'}}>Course: { courseDetails. description}</p>
                                <p style={{fontFamily:'math',color:'blue'}}>Course: { courseDetails. fee}</p>
                               

                                <button
                        style={styles.bookBtn} onClick={initiatePayment} disabled={loading}>
                        {loading ? 'Processing...' : 'Pay Now'}
                      </button>
                            </>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default KeyFuturesSection;




